var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermoboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61268 1.50656L12.9527 3.84656C13.4593 4.1199 13.4593 4.8999 12.9527 5.17323L8.61268 7.51323C8.22602 7.7199 7.77268 7.7199 7.38602 7.51323L3.04602 5.17323C2.53935 4.8999 2.53935 4.1199 3.04602 3.84656L7.38602 1.50656C7.77268 1.2999 8.22602 1.2999 8.61268 1.50656Z",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40732 6.75377L6.44065 8.77377C6.94065 9.02711 7.26065 9.54044 7.26065 10.1004V13.9138C7.26065 14.4671 6.68065 14.8204 6.18732 14.5738L2.15398 12.5538C1.65398 12.3004 1.33398 11.7871 1.33398 11.2271V7.41377C1.33398 6.86044 1.91398 6.50711 2.40732 6.75377Z",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5936 6.75377L9.56023 8.77377C9.06023 9.02711 8.74023 9.54044 8.74023 10.1004V13.9138C8.74023 14.4671 9.32023 14.8204 9.81357 14.5738L13.8469 12.5538C14.3469 12.3004 14.6669 11.7871 14.6669 11.2271V7.41377C14.6669 6.86044 14.0869 6.50711 13.5936 6.75377Z",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermoboxIcon);
export default __webpack_public_path__ + "static/media/thermobox-icon.44e16d9a43f8657cfb70f186824a137e.svg";
export { ForwardRef as ReactComponent };